import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { SuccessToast, ErrorToast } from "../../../components/toast/Toasts";
import { IHotel, IHotelDetails } from "../hotelModel";

export const getAllHotels = createAsyncThunk(
  "Hotels/FindAllHotels",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/FindAllHotels`,
        formData
      );
      return response.data?.Data as IHotel[];
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Hotels:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveHotels = createAsyncThunk(
  "Hotels/FindAllActiveHotels",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Hotels/FindAllActiveHotels`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching hotels:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createHotel = createAsyncThunk(
  "Hotels/InsertHotels",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/InsertHotels`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Hotel:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateHotel = createAsyncThunk(
  "Hotels/UpdateHotels",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/UpdateHotels`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Hotel:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteHotel = createAsyncThunk(
  "Hotels/DeleteHotels",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/DeleteHotels`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Hotel:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHotelByID = createAsyncThunk(
  "Hotels/FindByIDHotels",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/FindByIDHotels`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        HotelName: result?.HotelName,
        Address: result?.Address,
        CityID: result?.CityID,
        StateID: result?.StateID,
        CountryID: result?.CountryID,
        HotelCategory: result?.HotelCategory,
        WeekDays: result?.WeekDays
          ? result?.WeekDays?.split(", ")?.map((days: any) => days)
          : [],
        WeekEnds: result?.WeekEnds
          ? result?.WeekEnds?.split(", ")?.map((days: any) => days)
          : [],
        IsActive: result?.IsActive === true ? 1 : 2,
        WeekDaysRateList: result?.WeekDaysRateList || [],
        WeekEndRateList: result?.WeekEndRateList || [],
        SpecialDateRateList: result?.SpecialDateRateList || [],
        RegularDaysRateList: result?.RegularDaysRateList || [],

        HotelDescription: result?.HotelDescription || "",
        BookingURL: result?.BookingURL,
        Notes: result?.Notes,
        CancellationPolicy: result?.CancellationPolicy || "",
        URL: result?.URL,
        Bedroom: result?.Bedroom || "",
        LivingArea: result?.LivingArea || "",
        RoomAminities: result?.RoomAminities || "",
        BathroomFacilities: result?.BathroomFacilities || "",
        TotalRoom: result?.TotalRoom,
        SectorID: result?.SectorID,
        IsDisplay: result?.IsDisplay,

        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        HotelImages: result?.HotelImages
          ? result?.HotelImages?.map((image: any) => {
              return {
                ID: image?.ID ? image?.ID : null,
                HotelID: image?.HotelID ? image?.HotelID : null,
                InnerImageSrNo: image?.SrNo ? image?.SrNo : null,
                InnerImages: image?.ImagePath ? image?.ImagePath : "",
                InnerImageRemarks: image?.Remarks ? image?.Remarks : "",
              };
            })
          : [],
      } as IHotelDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Hotel:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveHotel = createAsyncThunk(
  "Hotels/ActiveInActiveHotels",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/ActiveInActiveHotels`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Hotel:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// Hotel Contacts ***************************************************************************************************
export const getAllHotelContacts = createAsyncThunk(
  "HotelContact/FindByHotelIDContact",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelContact/FindByHotelIDContact`,
        formData
      );
      const result = response.data?.Data as any;
      return result.HotelContactList?.map((contact: any) => {
        return {
          hotel_contact_id: contact?.ID,
          HotelID: contact?.HotelID,
          ContactPersonName: contact?.ContactPersonName,
          ContactPersonMobileNo: contact?.ContactPersonMobileNo,
          ContactPersonEmailID: contact?.ContactPersonEmailID,
          ContactPersonDesignation: contact?.ContactPersonDesignation,
          IsActive: contact?.IsActive === true ? 1 : 2,
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Hotel Contacts:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// export const getAllActiveHotelContacts = createAsyncThunk(
//   "Hotels/FindAllActiveHotels",
//   async () => {
//     try {
//       const response = await axiosApiInstance.get(
//         `${API_URL}/Hotels/FindAllActiveHotels`
//       );
//       return response.data?.Data;
//     } catch (error: any) {
//       // ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error Fetching hotels:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );

export const createHotelContact = createAsyncThunk(
  "HotelContact/InsertHotelContact",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelContact/InsertHotelContact`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Hotel Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateHotelContact = createAsyncThunk(
  "HotelContact/UpdateHotelContact",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelContact/UpdateHotelContact`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Hotel Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteHotelContact = createAsyncThunk(
  "HotelContact/DeleteHotelContact",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelContact/DeleteHotelContact`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Hotel Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHotelSpecialRate = createAsyncThunk(
  "HotelSpecialRate/GetHotelSpecialRate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelSpecialRate/GetHotelSpecialRate`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get Hotel Rate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHotelContactByID = createAsyncThunk(
  "HotelContact/FindByIDHotelContact",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelContact/FindByIDHotelContact`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        HotelID: result.HotelID,
        ContactPersonName: result?.ContactPersonName,
        ContactPersonMobileNo: result?.ContactPersonMobileNo,
        ContactPersonEmailID: result?.ContactPersonEmailID,
        ContactPersonDesignation: result?.ContactPersonDesignation,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Hotel Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveHotelContact = createAsyncThunk(
  "HotelContact/ActiveInActiveHotelContact",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelContact/ActiveInActiveHotelContact`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Hotel Contact:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// Hotel Room Category ***************************************************************************************************
export const getAllHotelRoomCategory = createAsyncThunk(
  "HotelRoomcatgeory/FindByHotelIDHotelRoomcatgeory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelRoomcatgeory/FindByHotelIDHotelRoomcatgeory`,
        formData
      );
      const result = response.data?.Data as any;
      return result?.map((roomCategory: any) => {
        return {
          hotel_room_category_id: roomCategory?.ID,
          HotelID: roomCategory?.HotelID,
          HotelName: roomCategory?.HotelName,
          RoomCategoryName: roomCategory?.RoomCategoryName,
          IsActive: roomCategory?.IsActive ? roomCategory?.IsActive : false,
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Hotel Room Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveHotelRoomCategory = createAsyncThunk(
  "HotelRoomcatgeory/FindAllActiveHotelRoomcatgeory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelRoomcatgeory/FindAllActiveHotelRoomcatgeory`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching hotels room category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createHotelRoomCategory = createAsyncThunk(
  "HotelRoomcatgeory/InsertHotelRoomcatgeory",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelRoomcatgeory/InsertHotelRoomcatgeory`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Hotel Room Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateHotelRoomCategory = createAsyncThunk(
  "HotelRoomcatgeory/UpdateHotelRoomcatgeory",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelRoomcatgeory/UpdateHotelRoomcatgeory`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Hotel Room Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteHotelRoomCategory = createAsyncThunk(
  "HotelRoomcatgeory/DeleteHotelRoomcatgeory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelRoomcatgeory/DeleteHotelRoomcatgeory`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Hotel Room Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHotelRoomCategoryByID = createAsyncThunk(
  "HotelRoomcatgeory/FindByIDHotelRoomcatgeory",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelRoomcatgeory/FindByIDHotelRoomcatgeory`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        HotelID: result.HotelID,
        HotelName: result?.HotelName,
        RoomCategoryName: result?.RoomCategoryName,
        IsActive: result?.IsActive,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Hotel Room Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveHotelRoomCategory = createAsyncThunk(
  "HotelRoomcatgeory/ActiveInActiveHotelRoomcatgeory",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelRoomcatgeory/ActiveInActiveHotelRoomcatgeory`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Hotel Room Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// Hotel Special Rate ***************************************************************************************************
export const getAllHotelSpecialRate = createAsyncThunk(
  "HotelSpecialRate/FindByHotelIDHotelSpecialRate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelSpecialRate/FindByHotelIDHotelSpecialRate`,
        formData
      );
      const result = response.data?.Data as any;
      return result?.map((roomCategory: any) => {
        return {
          hotel_room_category_id: roomCategory?.ID,
          HotelID: roomCategory?.HotelID,
          HotelName: roomCategory?.HotelName,
          RoomCategoryName: roomCategory?.RoomCategoryName,
          IsActive: roomCategory?.IsActive ? roomCategory?.IsActive : false,
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Hotel Room Category:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createHotelSpecialRate = createAsyncThunk(
  "HotelSpecialRate/InsertHotelSpecialRate",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelSpecialRate/InsertHotelSpecialRate`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Hotel Special Rate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateHotelSpecialRate = createAsyncThunk(
  "HotelSpecialRate/UpdateHotelSpecialRate",
  async (HotelData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelSpecialRate/UpdateHotelSpecialRate`,
        HotelData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Hotel Special Rate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteHotelSpecialRate = createAsyncThunk(
  "HotelSpecialRate/DeleteHotelSpecialRate",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelSpecialRate/DeleteHotelSpecialRate`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Hotel Special Rate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHotelSpecialRateByID = createAsyncThunk(
  "HotelSpecialRate/FindByIDHotelSpecialRate",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelSpecialRate/FindByIDHotelSpecialRate`,
        { ID }
      );
      return response.data?.Data as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Hotel Special Rate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveHotelSpecialRate = createAsyncThunk(
  "HotelSpecialRate/ActiveInActiveHotelSpecialRate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HotelSpecialRate/ActiveInActiveHotelSpecialRate`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Hotel Special Rate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const bulkUploadHotel = createAsyncThunk(
  "Hotels/BulkUploadHotels",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/BulkUploadHotels`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading hotel data:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateHotelImages = createAsyncThunk(
  "Hotels/HotelImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/HotelImageUpdate`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading hotel images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const deleteHotelImage = createAsyncThunk(
  "Hotels/DeleteHotelImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Hotels/DeleteHotelImage`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting hotel images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
